var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.dataToShow ? _c('div', [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Langue")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('input-text', {
    staticClass: "lg:w-1/2",
    attrs: {
      "error": true,
      "value": _vm.newLangue.name,
      "libelle": "Langue",
      "name": "langueName"
    },
    on: {
      "input": function (newValue) {
        _vm.newLangue.name = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center my-5"
  }, [false ? _c('p', {
    staticClass: "text-sm"
  }, [_vm._v("\n          " + _vm._s(_vm.descriptionNiveaux[_vm.niveaux[_vm.newLangue.niveau]]) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-5 flex justify-center"
  }, [_c('input-range', {
    staticClass: "lg:w-1/2",
    attrs: {
      "range-values": _vm.niveaux,
      "size-libelle": "text-sm",
      "name": "niveauLangue",
      "value": parseInt(_vm.newLangue.niveau)
    },
    on: {
      "input": function (newValue) {
        _vm.newLangue.niveau = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "ENREGISTRER",
      "typeShadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        _vm.langueToEdit ? _vm.modifyLangue() : _vm.addLangue();
      }
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }